export const inView = (el) => {
	const { bottom } = el.getBoundingClientRect();
	const { innerHeight } = window;

	const calculate = (btm) => {
		if (btm < 0) {
			return 100;
		} else if (btm <= innerHeight + el.clientHeight) {
			const totalHeight = innerHeight + el.clientHeight;
			const reversePer = (btm / totalHeight) * 100;
			const percentage = Number((-reversePer + 100).toFixed(2));
			return percentage;
		} else {
			return 0;
		}
	}

	// const rsBottom = bottom - innerHeight;

	return { reached: 0, leave: calculate(bottom) }
};

export const parallaxInit = (el, parallax = {}, parentEl = false) => {
	const pEl = parentEl || el.parentElement;
	const { isReverse, speed } = parallax;
	const newSpeed = isReverse ? speed : -speed;

	const screenPos = inView(pEl).leave;

	// If block is shown on screen
	if (0 <= screenPos <= 100) {
		const speedAmount = screenPos * newSpeed;
		const makeInCenter = speedAmount + (50 - (newSpeed * 50));

		el.style.top = `${makeInCenter}%`;
		el.style.transform = `translateY(-${makeInCenter}%)`;
	}
}

export const zoomInInit = (el, parentEl = false) => {
	const pEl = parentEl || el.parentElement;

	const screenPos = inView(pEl).leave;

	// If block is shown on screen
	if (0 <= screenPos <= 100) {
		const scaleAmount = Math.max(1, 1 + (screenPos / 100) * 0.5);

		el.style.scale = scaleAmount;
	}
}